/* GUTE GESTE · Shopify-Brücke für den migrierten Prototyp.
   - ggAsset(): alte /assets/-Pfade → Shopify-Dateien (CDN)
   - ggRoute(): alte Prototyp-URLs → Shopify-URLs
   - Link-Korrektur für dynamisch erzeugte Links
   Wird synchron im <head> geladen, damit Daten-Snippets darauf zugreifen können. */
(function (w) {
  'use strict';
  var CDN = (w.GG_CDN || 'https://cdn.shopify.com/s/files/1/1092/1302/4597/files/');
  var UML = { 'ä': 'ae', 'ö': 'oe', 'ü': 'ue', 'Ä': 'Ae', 'Ö': 'Oe', 'Ü': 'Ue', 'ß': 'ss' };
  function ggAsset(p) {
    if (typeof p !== 'string' || p.indexOf('/assets/') !== 0) return p;
    var path = p.split('?')[0].slice(8);
    try { path = decodeURIComponent(path); } catch (e) {}
    path = path.replace(/[äöüÄÖÜß]/g, function (c) { return UML[c]; });
    return CDN + 'gg-' + path.split('/').join('--');
  }
  var PAGES = ['alkoholfrei', 'anlaesse', 'bildwelt', 'design', 'firmen', 'geschenkfinder', 'gin-vergleich', 'glossar', 'kontakt', 'quellen', 'rechtliches', 'service', 'spirituosenmessen', 'ueber-uns', 'accessoires'];
  var ACC = { glaeser: 'gg-glaeser', stirrer: 'gg-stirrer', untersetzer: 'gg-untersetzer', 'bar-duo': 'gg-bar-duo' };
  function ggRoute(href) {
    if (typeof href !== 'string' || href.charAt(0) !== '/' || href.charAt(1) === '/') return href;
    var m = href.match(/^([^?#]*)(\?[^#]*)?(#.*)?$/), path = m[1], qs = m[2] || '', hash = m[3] || '';
    if (/^\/(products|collections|pages|blogs|cart|checkout|search|account|policies|cdn|apps|s\/)/.test(path)) return href;
    var seg = path.split('/').filter(Boolean), a = seg[0], b = seg[1], out = null;
    if (!seg.length) return href;
    switch (a) {
      case 'sets': out = b ? '/products/' + b : '/collections/geschenksets'; break;
      case 'geschenke': out = '/collections/geschenksets'; break;
      case 'gins':
        if (!b) out = '/pages/gins';
        else if (b.indexOf('gold-') === 0) out = '/pages/gold/' + b.slice(5);
        else { out = '/products/' + b; qs = qs ? qs + '&view=gin' : '?view=gin'; }
        break;
      case 'rezepte':
        if (!b) out = '/pages/rezepte';
        else if (b.indexOf('gold-') === 0) { out = '/pages/gold/' + b.slice(5); hash = hash || '#rezepte'; }
        else { out = '/products/' + b; qs = qs ? qs + '&view=rezepte' : '?view=rezepte'; }
        break;
      case 'tonics': out = b ? '/pages/tonic/' + b : '/pages/tonics'; break;
      case 'gold-edition': out = b ? '/pages/gold/' + b : '/pages/gold-edition'; break;
      case 'accessoires': out = b ? '/products/' + (ACC[b] || b) : '/pages/accessoires'; break;
      case 'magazin': out = b ? '/blogs/magazin/' + b : '/blogs/magazin'; break;
      case 'bildwelt': out = b === 'gin-mare' ? '/products/mare' : '/pages/gins'; break;
      default: if (PAGES.indexOf(a) > -1) out = '/pages/' + a;
    }
    return out ? out + qs + hash : href;
  }
  function fixData(v) {
    if (typeof v === 'string') return v.indexOf('/assets/') === 0 ? ggAsset(v) : v;
    if (Array.isArray(v)) { for (var i = 0; i < v.length; i++) v[i] = fixData(v[i]); return v; }
    if (v && typeof v === 'object') {
      for (var k in v) if (Object.prototype.hasOwnProperty.call(v, k)) {
        var x = v[k];
        if (typeof x === 'string' && (k === 'url' || k === 'setUrl') && x.charAt(0) === '/') v[k] = ggRoute(x);
        else v[k] = fixData(x);
      }
    }
    return v;
  }
  w.ggAsset = ggAsset; w.ggRoute = ggRoute; w.ggFixData = fixData;
  function fixNode(root) {
    if (!root || root.nodeType !== 1) return;
    var list = root.matches && root.matches('a[href^="/"],img[src^="/assets/"]') ? [root] : [];
    if (root.querySelectorAll) list = list.concat([].slice.call(root.querySelectorAll('a[href^="/"],img[src^="/assets/"]')));
    list.forEach(function (el) {
      if (el.tagName === 'IMG') { el.src = ggAsset(el.getAttribute('src')); return; }
      var h = el.getAttribute('href'), n = ggRoute(h);
      if (n !== h) el.setAttribute('href', n);
    });
  }
  w.ggFixLinks = fixNode;
  document.addEventListener('DOMContentLoaded', function () {
    fixNode(document.body);
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        if (m.type === 'attributes') fixNode(m.target);
        else m.addedNodes.forEach(fixNode);
      });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'src'] });
  });
})(window);
